import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@user-portal/wikr-components';

import { DATE_FORMAT } from 'constants/date';
import { CURRENCY_SIGN_MAP } from 'constants/currency';
import { SUBSCRIPTION_LABEL_STATES } from '../constants';

import { replaceUnderscoreToDash } from 'helpers/utils';
import { getFormattedDate } from 'helpers/date';

import SubscriptionStatusLabel from './subComponents/SubscriptionLabel';
import PeriodRow from './subComponents/PeriodRow';
import { IncludedInYourPlanRow } from './subComponents/IncludedInYourPlanRow';
import BillingPeriod from './subComponents/BillingPeriod';

import * as S from './styled';

import { IUpcomingProductProps } from '../types';

const UpcomingProduct = ({ upcomingProduct, isNextChargeAvailable, isUpgrade }: IUpcomingProductProps) => {
    const { t } = useTranslation();

    const autoRenewalDate = getFormattedDate(upcomingProduct.started_from as string, DATE_FORMAT);
    const price = upcomingProduct.price;

    const currencySign = CURRENCY_SIGN_MAP[upcomingProduct.currency] || upcomingProduct.currency;

    const period = upcomingProduct.subscription_period;

    return (
        <>
            <S.GeneralInfo $mb={16} $mt={24}>
                <SubscriptionStatusLabel state={SUBSCRIPTION_LABEL_STATES.UPCOMING} />
                <PeriodRow isTrial={false} period={period} />
                <S.SubscriptionCardRow>
                    <Text>{t('basics.price')}</Text>
                    <Text dataLocator="subscriptionPrice">{`${price} ${currencySign}`}</Text>
                </S.SubscriptionCardRow>
                <BillingPeriod period={period} />
                {isNextChargeAvailable && (
                    <S.SubscriptionCardRow>
                        <Text>{t('subscription.text.newChargeDate')}</Text>
                        <Text dataLocator="subscriptionNextChargeDate">{`${replaceUnderscoreToDash(autoRenewalDate)} UTC`}</Text>
                    </S.SubscriptionCardRow>
                )}
                {isUpgrade && <IncludedInYourPlanRow isCardRow />}
            </S.GeneralInfo>
            <S.Line $mb={20} />
        </>
    );
};

export default UpcomingProduct;
